import { ActionIcon, Tooltip } from "@mantine/core";

import { useCollapsable } from "../../Collapsable";

import type { ActionIconProps } from "@mantine/core";
import type { FC, ReactNode } from "react";

export type CollapsableToggleActionIconProps = {
  children?: ReactNode | ((opened: boolean) => ReactNode);
  tooltip?: string;
} & Omit<ActionIconProps, "children" | "color" | "onClick" | "variant">;

export const CollapsableToggleActionIcon: FC<CollapsableToggleActionIconProps> = ({
  children,
  tooltip,
  ...props
}) => {
  const { opened, toggle } = useCollapsable();

  return (
    <Tooltip
      label={tooltip}
      disabled={tooltip === undefined}
      events={{ hover: true, focus: true, touch: true }}
    >
      <ActionIcon {...props} color="primary" onClick={toggle} variant="light">
        {typeof children === "function" ? children(opened) : children}
      </ActionIcon>
    </Tooltip>
  );
};
